var map = {
	"./": 3999,
	"./FormIcon1": 4115,
	"./FormIcon1.tsx": 4115,
	"./FormIcon2": 3211,
	"./FormIcon2.tsx": 3211,
	"./close.svg": 1571,
	"./file.svg": 1858,
	"./geo.svg": 1886,
	"./index": 3999,
	"./index.ts": 3999,
	"./mailbox.svg": 9047,
	"./telephone.svg": 1554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1512;